import api from './api';

export const getSearchSuggestions = (q, { signal } = {}) =>
  api.get('/discovery/suggest', { params: { q }, signal }).then((r) => r.data);

export const getSearchCorrection = (q) =>
  api.get('/discovery/correct', { params: { q } }).then((r) => r.data);

export const getAlsoBought = (productId) =>
  api.get(`/discovery/also-bought/${productId}`).then((r) => r.data);

export const getPopularity = () => api.get('/discovery/popularity').then((r) => r.data);

export const getSizeChart = (params) => api.get('/size-charts/resolve', { params }).then((r) => r.data);

// admin
export const listSizeCharts = () => api.get('/size-charts').then((r) => r.data);
export const createSizeChart = (data) => api.post('/size-charts', data).then((r) => r.data);
export const updateSizeChart = (id, data) => api.put(`/size-charts/${id}`, data).then((r) => r.data);
export const deleteSizeChart = (id) => api.delete(`/size-charts/${id}`).then((r) => r.data);

// review photos (logged-in customers)
export const uploadReviewPhoto = (file) => {
  const fd = new FormData();
  fd.append('image', file);
  return api.post('/upload/review-photo', fd).then((r) => r.data.url);
};
